import React, { Component } from 'react';
import PropTypes from 'prop-types';


import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import { Box } from '@mui/material';

const s:any = {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: 'spacing(1)',
    marginRight: 'spacing(1)',
    //width: 200,
  },
  hide:{
    display:'none',
  },
};

class FCheckBox extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      next: true,
      idtype: this.props.idtype
    };
  }

  handleChange = (name:any) => (event:any) => {
    this.setState({
      [name]: event.target.value,
    });
  };

  render() {
    const {id,label,value,onChange,divider,classes } = this.props;
    //const dataset = [{k:'',v:''},{k:'',v:''}];

    return (
      <Box sx={{...s.root}}>
        <TextField
            label={label}
            id={id}
            name={id}
            type={'text'}
            margin='dense'
            // {...options}
            // fullWidth={true}
            sx={{...s.textField}}
            value={value}
            onChange={onChange(id)}
          />
        {divider && <Divider />}
      </Box>
    );
  }
}

FCheckBox.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default FCheckBox;
